import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  Output,
} from '@angular/core';

@Directive({ selector: '[appInView]' })
export class InViewDirective implements AfterViewInit, OnDestroy {
  @Output() inView: EventEmitter<boolean> = new EventEmitter();
  private observer: IntersectionObserver;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.inView.emit(entry.isIntersecting);
        });
      },
      {
        root: null, // observing for viewport
        threshold: 0.1, // percentage of target's visibility the observer's callback should be executed
      },
    );

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
